import type { GraphQLAuditItem } from '@internal-audit/domain/graphql-types';
import { Text, Badge, BadgeSize, BadgeVariant } from '@soteria/design-system-ve';

import { LikeDislikeButtons } from '../../LikeDislikeButtons/LikeDislikeButtons';
import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

interface PolicyAssessmentRowProps {
  policy: NonNullable<NonNullable<GraphQLAuditItem['contentSnapshot']>['triggeredPolicies']>[0];
  assessment?: {
    policyId: string;
    policyName: string;
    isCorrect: boolean | null;
    comments?: string;
  };
  onAssessmentChange: (assessment: { policyId: string; policyName: string; isCorrect: boolean | null; comments?: string }) => void;
  disabled?: boolean;
}

export function PolicyAssessmentRow({ policy, assessment, onAssessmentChange, disabled = false }: PolicyAssessmentRowProps) {
  const handleLikeDislikeChange = (value: boolean | null) => {
    onAssessmentChange({
      policyId: policy.id,
      policyName: policy.name,
      isCorrect: value,
      comments: assessment?.comments || '',
    });
  };

  return (
    <div className={spacingStyles.assessmentRow}>
      <Text className={styles.policyName}>{policy.name}</Text>
      <Badge size={BadgeSize.Small} text="TRIGGERED" variant={BadgeVariant.Warning} />
      <LikeDislikeButtons disabled={disabled} name={`policy-${policy.id}`} value={assessment?.isCorrect ?? null} onChange={handleLikeDislikeChange} />
    </div>
  );
}
